import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Box, Tabs, Tab, Tooltip } from '@mui/material';

/** Material UI Icons. */
import CategoryIcon from '@mui/icons-material/Category';
import CalculateIcon from '@mui/icons-material/Calculate';
import InventoryIcon from '@mui/icons-material/Inventory';

/** Internal Components. */
import { callAPI } from 'shared/api/callApi';

import ItemCategories from './ItemCategories/ItemCategories';
import ItemFormulas from './ItemFormula/ItemFormulas';
import ItemList from './ItemList/ItemList';

const TABS = [
    { label: 'Item Categories', icon: <CategoryIcon /> },
    { label: 'Item Formulas', icon: <CalculateIcon /> },
    { label: 'Item List', icon: <InventoryIcon /> },
];

export default function DutyConfiguration({
    userEmail,
    getAccessTokenSilently,
    loadingState,
    setLoadingState,
    itemFormulasRows,
    setItemFormulasRows,
}) {
    /** State for the tab value. */
    const [value, setValue] = useState(0);

    /** Handler for tab change event. */
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ display: 'flex', height: '82.5vh' }}>
            <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                sx={{
                    borderRight: 1,
                    borderColor: 'divider',
                    width: 70,
                    '& .MuiTab-root': {
                        minHeight: 70,
                        minWidth: 0,
                        p: 0,
                    },
                    '& .Mui-selected': {
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2',
                    },
                }}
            >
                {TABS.map((tab, index) => (
                    <Tooltip key={index} title={tab.label} placement="right">
                        <Tab icon={tab.icon} />
                    </Tooltip>
                ))}
            </Tabs>

            <Box sx={{ flex: 1, overflow: 'auto' }}>
                {value === 0 && (
                    <ItemCategories
                        userEmail={userEmail}
                        getAccessTokenSilently={getAccessTokenSilently}
                        loadingState={loadingState}
                        setLoadingState={setLoadingState}
                    />
                )}
                {value === 1 && (
                    <ItemFormulas
                        userEmail={userEmail}
                        getAccessTokenSilently={getAccessTokenSilently}
                        loadingState={loadingState}
                        setLoadingState={setLoadingState}
                        itemFormulasRows={itemFormulasRows}
                        setItemFormulasRows={setItemFormulasRows}
                    />
                )}
                {value === 2 && (
                    <ItemList
                        userEmail={userEmail}
                        getAccessTokenSilently={getAccessTokenSilently}
                        loadingState={loadingState}
                        setLoadingState={setLoadingState}
                        itemFormulasRows={itemFormulasRows}
                    />
                )}
            </Box>
        </Box>
    );
}
